export default __webpack_public_path__ + "static/media/lemoon.335b4922.svg";